import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { getCookie } from "./utils";

const cookie_lang = getCookie("lang")
const lang = cookie_lang !== "" ? cookie_lang : "cz"

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: { translations: {}},  // same as keys
      de: {
        translations: {
          "Yes": "Ja",
          "No": "Nein",
          "Czech": "Tschechisch",
          "Czech description": "Beschreibung tschechische",
          "English": "Englisch",
          "English description": "Beschreibung Englisch",
          "German": "Deutsch",
          "German description": "Beschreibung deutsch",
          "Tool": "Werkzeug",
          "Machine tool": "Werkzeugmaschine",
          "Technology": "Technologie",
          "General information": "Allgemeine Information",
          "Link": "Link",
          "Picture": "Bild",
          "Pictures": "Bilder",
          "Videos": "Videos",
          "Last changed": "zuletzt geändert",
          "Created / changed by": "erstell / geändert von",
          "Required field": "Pflichtfeld",
          "New": "Neu",
          "Save": "Speichern",
          "Add Video Link": "Video Link hinzufügen",
          "Delete": "Löschen",
          "Upload a picture": "Bild hochladen",
          "Category": "Kategorie",
          "Undefined term": "undefinierter Begriff",
          "Technical terminology glossary": "Technisch-technologisches Glossar",
          "Term": "Begriff",
          "Export all to XLS": "Alle nach EXCEL exportieren",
          "Export selection to XLS": "Ausgewählte nach EXCEL exportieren",
          "Administration": "Verwaltung",
          "Create, edit and delete form": "Formular erstellen, bearbeiten, löschen",
          "Defined terms": "definierte Begriffe",
          "Return to homepage": "Zurück zur Startseite",
          "Clicking on a term in the table below will result in the form being filled with the term data. The term may be edited, deleted or used as a template for a new term.": "Wenn Sie auf einen Begriff in der Tabelle klicken, wird das Formular mit den Eingabedaten gefüllt. Der Eintrag kann dann bearbeitet, gelöscht oder als Vorlage für einen neuen Begriff verwendet werden."
        }
      },
      cz: {
        translations: {
          "Yes": "Ano",
          "No": "Ne",
          "Czech": "Česky",
          "Czech description": "Český popis",
          "English": "Anglicky",
          "English description": "Anglický popis",
          "German": "Německy",
          "German description": "Německý popis",
          "Tool": "Nástroj",
          "Machine tool": "Součástka",
          "Technology": "Technologie",
          "General information": "Obecná informace",
          "Link": "Odkaz",
          "Picture": "Obrázek",
          "Pictures": "Obrázky",
          "Videos": "Videa",
          "Last changed": "Poslední změna",
          "Created / changed by": "Vložil / upravil",
          "Required field": "Pole je povinné",
          "New": "Nový",
          "Save": "Uložit",
          "Add Video Link": "Přidat odkaz na video",
          "Delete": "Smazat",
          "Upload a picture": "Nahrát obrázek",
          "Category": "Kategorie",
          "Undefined term": "Nedefinovaný pojem",
          "Technical terminology glossary": "Slovník odborných pojmů",
          "Term": "Pojem",
          "Export all to XLS": "Exportovat vše do XLS",
          "Export selection to XLS": "Exportovat výběr do XLS",
          "Administration": "Administrace",
          "Create, edit and delete form": "Formulář pro vkládání, úpravu a mazání pojmů",
          "Defined terms": "Definované pojmy",
          "Return to homepage": "Zpět na hlavní stránku",
          "Clicking on a term in the table below will result in the form being filled with the term data. The term may be edited, deleted or used as a template for a new term.": "Po kliknutí na pojem v tabulce níže bude formulář předvyplněn. Poté lze termín upravit, smazat nebo ho použít jako šablonu pro nový pojem."
        }
      }
    },
    lng: lang,
    fallbackLng: "en",
    debug: false,

    // have a common namespace used around the full app
    ns: ["translations"],
    defaultNS: "translations",

    keySeparator: false,
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;
